import React, { useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import getValidationErrors from '../../utils/getValidationErrors';
import { useAlert } from '../../hooks/alert';

import Input from '../../components/Input';

import journals from '../../assets/jornal.png';
import journal from '../../assets/jornal1.png';
import Select from '../../components/Select';

interface searchDetailedData {
  company: string;
  cnpj: string;
  datei: string;
  datef: string;
  type: string;
}

interface searchByEditionData {
  date: string;
}

const Home: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const formDateRef = useRef<FormHandles>(null);

  const { showAlert } = useAlert();

  const history = useHistory();

  const handleSubmitDetailed = useCallback(
    async (data: searchDetailedData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          company: Yup.string().notRequired(),
          cnpj: Yup.string().notRequired(),
          datei: Yup.string().notRequired(),
          datef: Yup.string().notRequired(),
          type: Yup.string().notRequired(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (
          !data.company &&
          !data.cnpj &&
          !data.datei &&
          !data.datef &&
          !data.type
        ) {
          showAlert({
            type: 'error',
            title: 'Informe os campos',
            description: 'Informe pelo menos um campo para pesquisar',
          });
          return;
        }

        history.push({
          pathname: `search`,
          search: `?company=${data.company}&cnpj=${data.cnpj}&datei=${data.datei}&datef=${data.datef}&type=${data.type}`,
        });
      } catch (error) {
        const errors = getValidationErrors(error);

        formRef.current?.setErrors(errors);
      }
    },
    [history, showAlert],
  );

  const handleSubmitEditionDate = useCallback(
    async (data: searchByEditionData) => {
      if (!data.date) {
        showAlert({
          type: 'error',
          title: 'Digite a data da edição',
          description: 'Digite a data da edição para pesquisar',
        });
        return;
      }

      history.push({
        pathname: `editions`,
        search: `?date=${data.date}`,
      });
    },
    [history, showAlert],
  );

  return (
    <>
      <div className="row">
        <div className="col-12 col-xl-5">
          <Form onSubmit={handleSubmitDetailed} ref={formRef}>
            <h5 className="spacer text-center">PESQUISA DETALHADA</h5>
            <p>
              O Jornal do Comércio possui espaço específico para publicações legais no impresso e digital.
            </p>

            <div className="spacer" />

            <div className="form-group">
              <label htmlFor="company">RAZÃO SOCIAL</label>
              <Input
                name="company"
                type="text"
                className="form-control"
                id="company"
              />
            </div>

            {/* <div className="form-group">
              <label htmlFor="cnpj">CNPJ</label>
              <Input
                name="cnpj"
                type="text"
                className="form-control"
                id="cnpj"
              />
            </div> */}

            <div className="form-group">
              <label htmlFor="client_id">TIPO DO MATERIAL</label>
              <Select className="form-control" name="type" id="type">
                <option value="">---</option>
                <option value="Edital">Editais</option>
                <option value="Ata">Atas</option>
                <option value="Balanço">Balanços</option>
                <option value="Outro">Outros</option>
              </Select>
            </div>

            <div className="form-group">
              <label>DATA DA PUBLICAÇÃO</label>
              <div className="row d-flex align-items-center">
                <div className="col-5">
                  <Input name="datei" type="date" className="form-control" />
                </div>
                <div className="col-2">ATÉ</div>
                <div className="col-5">
                  <Input name="datef" type="date" className="form-control" />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <button type="submit" className="btn btn-primary bottom">
                PESQUISAR
              </button>
            </div>
          </Form>
        </div>
        <div className="col-12 col-xl-5 offset-xl-2 offset-0">
          {/* Espaçamento mobile */}
          <div className="d-block d-xl-none mb-4" />
          <h5 className="spacer text-center">PESQUISA RESUMIDA</h5>
          <p>
            O lugar certo para as empresas que buscam confiança e tradição publicarem atas, avisos, balanços, comunicados aos acionistas, convocação e editais, e todo o tipo de publicação legal.
          </p>

          <div className="spacer" />

          <div className="form-group form-text">
            <p>REALIZAR PESQUISA NO 2º CADERNO:</p>
          </div>

          <div className="row form-group">
            <div className="col">
              <img src={journals} alt="Todas as edições" />
            </div>
            <div className="col text-center">
              <img src={journal} alt="Edição do dia" />
            </div>
          </div>

          <div className="d-flex justify-content-around form-group">
            <Link className="btn btn-primary bottom" to="editions">
              TODAS AS EDIÇÕES
            </Link>
            <Link className="btn btn-primary bottom" to="search">
              EDIÇÃO DO DIA
            </Link>
          </div>

          <Form onSubmit={handleSubmitEditionDate} ref={formDateRef}>
            <div className="form-group">
              <label htmlFor="data">DATA DA PUBLICAÇÃO</label>
              <Input
                id="date"
                name="date"
                type="date"
                className="form-control"
              />
            </div>

            <div className="d-flex justify-content-center">
              <button type="submit" className="btn btn-primary bottom">
                ACESSO RÁPIDO
              </button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Home;
